import { getEndpointPlugin } from "@smithy/middleware-endpoint";
import { getSerdePlugin } from "@smithy/middleware-serde";
import { Command as $Command } from "@smithy/smithy-client";
import { commonParams } from "../endpoint/EndpointParameters";
import { SendChannelMessageRequestFilterSensitiveLog, } from "../models/models_0";
import { de_SendChannelMessageCommand, se_SendChannelMessageCommand } from "../protocols/Aws_restJson1";
export { $Command };
export class SendChannelMessageCommand extends $Command
    .classBuilder()
    .ep({
    ...commonParams,
})
    .m(function (Command, cs, config, o) {
    return [
        getSerdePlugin(config, this.serialize, this.deserialize),
        getEndpointPlugin(config, Command.getEndpointParameterInstructions()),
    ];
})
    .s("ChimeMessagingService", "SendChannelMessage", {})
    .n("ChimeSDKMessagingClient", "SendChannelMessageCommand")
    .f(SendChannelMessageRequestFilterSensitiveLog, void 0)
    .ser(se_SendChannelMessageCommand)
    .de(de_SendChannelMessageCommand)
    .build() {
}
